import React, { useState } from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import { useAuth } from '../../hooks/useAuth';

interface MetricUpdateButtonProps {
  metricKey: string;
  onUpdate: (metricKey: string) => Promise<void>;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

/**
 * メトリクス更新ボタンコンポーネント
 * - 管理者ユーザーのみ表示される
 * - クリック時に対応するメトリクスを更新する
 */
const MetricUpdateButton: React.FC<MetricUpdateButtonProps> = ({
  metricKey,
  onUpdate,
  disabled = false,
  size = 'small',
  color = 'primary'
}) => {
  const { user } = useAuth();
  const [ loading, setLoading ] = useState(false);
  // ADMIN権限がない場合は何も表示しない
  if (user?.role !== 'ADMIN') {
    return null;
  }
  const handleClick = async() => {
    setLoading(true);
    try {
      await onUpdate(metricKey);
    } catch (error) {
      console.error(`Error updating metric ${metricKey}:`, error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Tooltip title="このセクションのデータを今すぐ更新" arrow>
      <Button
        variant="outlined"
        color={color}
        size={size}
        disabled={disabled || loading}
        onClick={handleClick}
        startIcon={loading ? <CircularProgress size={16}/> : <RefreshIcon/>}
        sx={{
          minWidth: 'auto',
          ml: 1,
          px: 1,
          '& .MuiButton-startIcon': {
            mr: size === 'small' ? 0 : 0.5
          }
        }}
      >
        {size === 'small' ? '' : '更新'}
      </Button>
    </Tooltip>
  );
};
export default MetricUpdateButton;
